// 1. Enum for Popup Identifiers (Extend this as needed)
export enum PopupIdentifier {
  KYC_PENDING_REVIEW = "KYC_PENDING_REVIEW",
  KYC_STATUS_UPDATE = "KYC_STATUS_UPDATE",
  KYC_DEV = "KYC_DEV",
  WELCOME_ONBOARDING = "WELCOME_ONBOARDING",
  SESSION_EXPIRING = "SESSION_EXPIRING",
  FEATURE_ANNOUNCEMENT = "FEATURE_ANNOUNCEMENT",
}

// 2. Data Types
export interface PopupItem {
  identifier: PopupIdentifier;
  component: React.ReactNode;
  defaultDuration?: number | null; // in ms or null
  maxWidth?: string;
}
